import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { subscribeStarviewX } from '../../api/starviewApi';

// The membership page the chains build their business on (A-List, Unlimited,
// Movie Club) - StarView X, now joinable on the web. Billing runs on the
// account's Galaxies balance, same as in the app.
const PERKS = [
  ['🎟️', 'A free movie ticket credit every month'],
  ['✦', 'Bonus Galaxies and 4× points events'],
  ['🍿', 'Member pricing on OrderUp and concessions rewards'],
  ['🚀', 'Early access to premieres and watch parties'],
  ['🌍', 'Works in every StarView market, app and web'],
];

export default function StarViewX() {
  const { isAuthenticated, user, authFetch } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState(null);

  const join = async (billingCycle) => {
    if (!isAuthenticated) { navigate('/Login?next=/starview-x'); return; }
    setBusy(true); setMessage(null);
    try {
      await subscribeStarviewX(authFetch, billingCycle);
      setMessage({ ok: true, text: 'Welcome to StarView X! Your membership is active on this account everywhere.' });
    } catch (err) {
      const text = /galax/i.test(err.message || '')
        ? 'Not enough Galaxies on your account - top up in the StarView app, then join here.'
        : (err.message || 'Could not start the membership.');
      setMessage({ ok: false, text });
    } finally { setBusy(false); }
  };

  return (
    <main style={{ minHeight: '70vh', background: '#0b0c1e', color: '#fff', padding: '110px 20px 60px' }}>
      <div style={{ maxWidth: 760, margin: '0 auto', textAlign: 'center' }}>
        <p style={{ fontSize: 11, letterSpacing: '0.2em', textTransform: 'uppercase', color: '#CFAA41', fontWeight: 700 }}>Membership</p>
        <h1 style={{ fontSize: 40, margin: '6px 0' }}>StarView <span style={{ color: '#CFAA41' }}>X</span></h1>
        <p style={{ opacity: 0.75, maxWidth: 520, margin: '0 auto 26px' }}>
          The membership for people who never miss a premiere - in any of 199 countries.
        </p>
        <div style={{ textAlign: 'left', maxWidth: 460, margin: '0 auto 30px', display: 'grid', gap: 10 }}>
          {PERKS.map(([icon, text]) => (
            <div key={text} style={{ display: 'flex', gap: 12, alignItems: 'center', background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 12, padding: '12px 16px' }}>
              <span aria-hidden="true" style={{ fontSize: 18 }}>{icon}</span><span>{text}</span>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
          <button onClick={() => join('monthly')} disabled={busy}
            style={{ background: '#CFAA41', color: '#141021', fontWeight: 800, borderRadius: 999, padding: '13px 30px', border: 'none', cursor: 'pointer', fontSize: 15 }}>
            {busy ? 'One moment…' : 'Join monthly'}
          </button>
          <button onClick={() => join('annual')} disabled={busy}
            style={{ background: 'transparent', color: '#fff', fontWeight: 800, borderRadius: 999, padding: '13px 30px', border: '1px solid rgba(255,255,255,0.4)', cursor: 'pointer', fontSize: 15 }}>
            {busy ? 'One moment…' : 'Join annual (best value)'}
          </button>
        </div>
        <p style={{ opacity: 0.55, fontSize: 13, marginTop: 14 }}>
          Billed in Galaxies from your account balance{isAuthenticated && user ? ` (you have ${Number(user.galaxies || 0).toLocaleString()} ✦)` : ''}.
          Manage or cancel anytime in the app.
        </p>
        {message && (
          <p role="status" style={{ marginTop: 16, color: message.ok ? '#7fd6a4' : '#ff9d9d', fontWeight: 600 }}>
            {message.text}{!message.ok && <> · <Link to="/get-the-app" style={{ color: '#38BDF8' }}>get the app</Link></>}
          </p>
        )}
      </div>
    </main>
  );
}
